import { defineMessages, MessageDescriptor } from "react-intl";
import { PrepCostSpecialHandling } from "../types";

export const PREP_COST_SPECIAL_HANDLING_LABELS: Record<PrepCostSpecialHandling, MessageDescriptor> = defineMessages({
  minimum: {
    id: "inbounds.prep.costSpecialHandling.minimum",
    defaultMessage: "+",
  },
});
